// ----------------------------------------------------------------------
// <copyright file="Izenda.LabelDropDownList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import DropDown from 'share/components/controls/Izenda.DropDown';
import Validator from 'share/components/hoc/Izenda.Validator';
import { CONSTRAINTS } from 'logic/data/Izenda.FilterLookupConstants';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

const ValidatorDropDown = Validator()(DropDown);
const LabelDropDownList = (props: any) => {
  return (
    <div className='form-group'>
      <label className='control-label col-xs-4'>{props.label}</label>
      <div className='col-xs-8'>
        <ValidatorDropDown
          group={props.label}
          validations={CONSTRAINTS}
          options={props.options}
          onChange={props.onChange}
          value={props.value}
          valueField='key'
          labelField='value'
        />
      </div>
    </div>
  );
};

LabelDropDownList.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired
};

export default observer(LabelDropDownList);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/FilterValue/Izenda.LabelDropDownList.jsx